import { atom, useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";

const navbarHiddenAtom = atom(false);

export function useNavMenuHidden() {
    return useAtomValue(navbarHiddenAtom);
}

/**
 * Helper hook to disable the navbar on the current page.
 */
export const useHideNavMenu = () => {
    const setNavbarHidden = useSetAtom(navbarHiddenAtom);

    useEffect(() => {
        setNavbarHidden(true);

        return () => {
            setNavbarHidden(false);
        };
    }, [setNavbarHidden]);
};
